<script>
export default {
  data() {
    return {
      filename: '',
      loading: true,
      filter: {
        index: this.mediaIndex,
        order: 'created_at'
      },
      pagedItems: {},
      dataUrl: Scoop.baseUrl + '/mediaserver/components/media-of-index-selection',
      order: ''
    }
  },
  props: {
    mediaIndex: String,
    show: Boolean,
    mediaPaginationLimit: {
      type: Number,
      default: 12
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fetchMedias();

          this.$nextTick(() => {
            $(this.$refs.mediaIndexMediaSelectionDialog).on('hidden.bs.modal', () => {
              this.close();
            }).modal('show');
          });
        }
      },
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    searchMedias() {
      this.fetchMedias();
    },
    fetchMedias(page = 1) {
      const params = this.filter;
      params.page = page;
      params.limit = this.mediaPaginationLimit

      axios
          .get(this.dataUrl, {params: params})
          .then((response) => {
            this.pagedItems = response.data;
          })
    },
    mediaSelected(mediaItem) {
      this.$emit('media-selected', mediaItem)
    }
  },
}
</script>
<style lang="scss" scoped>
.media-selector-filters {
  display: flex;

  > div {
    display: flex;
    flex-direction: column;
    margin-right: 1em;

    > label {
      margin-left: 2px;
      margin-right: auto;
    }
  }

  > .search-button {
    margin-top: auto;
  }

  > .fileNameSearchBox {
    flex-grow: 1;
  }
}

.search-button {
  display: flex;

  > button {
    margin-right: auto;
  }
}

.media-row {
  overflow: scroll;
  height: 60vh;

  .medias {
    display: flex;
    flex-wrap: wrap;
  }
}

.modal-footer {
  text-align: center;
}

.upload-media-file {
  width: 25%;

  img {
    width: 100%;
  }

  small {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
  }
}
</style>
<template>
  <div ref="mediaIndexMediaSelectionDialog" class="modal inmodal" tabindex="-1"
       role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only" v-text="__('scoop-os.labels.close')"></span>
          </button>
          <h4 class="modal-title"
              v-text="__('scoop-os.media.media_of_index_selection_dialog.headline')"></h4>
          <hr>
          <div class="media-selector-filters">
            <div>
              <label for="sorting">Sortierung</label>
              <select id="sorting" class="form-control" v-model="filter.order">
                <option value="created_at">importiert am ↑</option>
                <option value="created_at_desc">importiert am ↓</option>
                <option value="last_change">letzte Änderung am ↑</option>
                <option value="last_change_desc">letzte Änderung am ↓</option>
                <option value="filename">Dateiname ↑</option>
                <option value="filename_desc">Dateiname ↓</option>
              </select>
            </div>
            <div class="fileNameSearchBox">
              <label for="filenameSearch">Dateiname</label>
              <input type="text" id="filenameSearch" class="form-control" v-model="filter.filename" v-on:keyup.enter="searchMedias">
            </div>
            <button class="btn btn-primary search-button" @click="searchMedias">Suchen</button>
          </div>
        </div>
        <div class="modal-body">
          <div class="row media-row">
            <div class="col-sm-12">
              <div class="medias">
                <div class="upload-media-file" v-for="mediaItem in pagedItems.data" :key="mediaItem.id" @click="mediaSelected(mediaItem)">
                  <div class="file">
                    <img :src="mediaItem.previewImageUrl">
                    <div class="fileinfo">
                      <div class="file-name ellipsis">
                        <small>{{ mediaItem.filename }}</small>
                        <small>Importiert {{ mediaItem.created_at }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <pagination
              :data="pagedItems"
              :limit=5
              align="center"
              @pagination-change-page="fetchMedias"
              :show-disabled=true
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>
